import withShipment from '../withShipment';
import { userInfoSelector } from '../redux/selectors/auth';

// Connect a Hive screen to the current user so it can read `userInfo.routes`
// (which apps are installed). Uses the house-style withShipment HOC.
const connectUser = (Component) =>
  withShipment(
    {
      mapStateToProps: (state) => ({ userInfo: userInfoSelector(state) }),
    },
    Component
  );

export default connectUser;
